module.exports = __webpack_public_path__ + "media/images/signatures/zsofi_signature_black-9a97517ae9d1d0636d7209fd795b878e.jpg";